<template>
  <div
    :id="gramId"
    class="ud-Visit_Gram ud-Visit_Gram_Action"
    :class="{ 'ud-Visit_Gram_Omo': isOmo }"
  >
    <div class="ud-Visit_GramIcon">
      <div class="ud-Visit_GramIcon_Circle">
        <Icon :icon="iconEvent" :size="17" :color="iconColor" />
      </div>
    </div>
    <div class="ud-Visit_GramBody">
      <div class="ud-Visit_GramTime">{{ time }}</div>
      <div class="ud-Visit_GramAction">{{ title }}</div>
      <div v-if="hasConversionAttributes" class="ud-Visit_GramActionDetail">
        <div
          v-for="cvAttr in conversionAttributes"
          :key="cvAttr.id"
          class="ud-Visit_GramActionDetailRow"
        >
          <div class="ud-Visit_GramActionDetailKey">{{ cvAttr.name }}</div>
          <div class="ud-Visit_GramActionDetailValue">{{ cvAttr.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import GramBase from "@/components/observation/visit/gram/GramBase.vue";
import Icon from "@/components/Icon.vue";
import { Icons } from "@/const/Icons";
import { Gram } from "@/models/Gram";
import { Colors } from "@/const/Colors";

@Component({
  components: { Icon }
})
export default class GramEvent extends GramBase {
  @Prop({ type: Gram, required: true })
  gram!: Gram;

  @Prop({ type: Boolean, required: true })
  isOmo!: boolean;

  iconEvent = Icons.Event;
  iconColor = Colors.Blue900;

  get conversionAttributes(): {
    id: number;
    value: string;
  }[] {
    return this.gram.conversionAttributes;
  }

  get hasConversionAttributes(): boolean {
    return 0 < this.conversionAttributes.length;
  }

  get gramId(): string {
    return this.gram.id;
  }

  get time(): string {
    return this.gram.timeTx;
  }

  get title(): string {
    return this.gram.eventName;
  }
}
</script>
